import './PortProductPanel.css'
import 'antd/dist/reset.css'
import React from 'react'
import { Divider, Row, Col, Button } from 'antd'
import {
  customers,
  varieties,
  getProductsOfCustomer,
  getProductsOfVariety,
} from '../../products/ProductProvider'

export default class PortProductPanel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {}

  render() {
    return this.props.entry == 'customer' ? (
      <div>
        {customers.map((customer) => {
          return (
            <div>
              {' '}
              {this.getProductTitle(customer.name)}
              <Divider style={{ marginTop: 0, marginBottom: 0 }} />
              <div className="PortProductPanelRow">
                {this.getCustomerProducts(customer.cid)}
              </div>
            </div>
          )
        })}
      </div>
    ) : (
      <div>
        {varieties.map((variety) => {
          return (
            <div>
              {' '}
              {this.getProductTitle(variety.name, variety)}
              <Divider style={{ marginTop: 0, marginBottom: 0 }} />
              <div className="PortProductPanelRow">
                {this.getVarietyProducts(variety.vid)}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  getCustomerProducts = (cid) => {
    const products = getProductsOfCustomer(cid)
    var sp = 24 / products.length
    if (sp < 12) {
      sp = 12
    }
    return (
      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32, xl: 40, xxl: 48 }, 40]}>
        {products.map((product) => (
          <Col span={sp}>{this.getProductCard(product)}</Col>
        ))}
      </Row>
    )
  }

  getVarietyProducts = (vid) => {
    const products = getProductsOfVariety(vid, 6)
    var sp = 24 / products.length
    if (sp < 12) {
      sp = 12
    }
    return (
      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32, xl: 40, xxl: 48 }, 40]}>
        {products.map((product) => (
          <Col span={sp}>{this.getProductCard(product)}</Col>
        ))}
      </Row>
    )
  }

  getProductTitle = (titleName, variety) => {
    return (
      <div className="PortProductPanelTitleLayout">
        <div className="PortProductPanelTitle">{titleName}</div>
        {variety && variety.trimmed ? (
          <Button
            color="blue"
            variant="link"
            style={{
              fontSize: 12,
              fontWeight: 'bold',
              fontFamily: 'MyCustomizedFont',
            }}
            onClick={() => {
              this.props.handleCollapse()
              this.viewProductListOfVariety(variety.vid)
            }}
          >
            查看所有
          </Button>
        ) : null}
      </div>
    )
  }

  getProductCard = (product) => {
    return product ? (
      <div
        className="PortProductPanelCard"
        onClick={() => {
          this.props.handleCollapse()
          this.viewProductDetail(product.pid)
        }}
      >
        <img className="PortProductPanelCardImage" src={product.picture} />
        <div className="PortProductPanelCardName">{product.name}</div>
      </div>
    ) : (
      <div />
    )
  }

  viewProductDetail = (pid) => {
    this.props.history.push('/product?pid=' + pid)
  }

  viewProductList = () => {
    this.props.history.push('/product_list')
  }

  viewProductListOfVariety = (vid) => {
    this.props.history.push('/product_list?vid=' + vid)
  }
}
